import { extendTheme } from '@mui/joy/styles';

/** Shared ApexOS color, type, radius and shadow tokens. */

const primary = {
  50: '#f4eefe',
  100: '#e6d9fd',
  200: '#cdb4fb',
  300: '#b088f8',
  400: '#9258f4',
  500: '#7013f5',
  600: '#5d0fce',
  700: '#4a0ca6',
  800: '#380980',
  900: '#28075c',
};

export const appTheme = extendTheme({
  // Plus Jakarta Sans (a modern geometric sans with subtly rounded terminals that
  // echo the rounded glass cards) is the app typeface; it's self-hosted via
  // @fontsource (imported in unified-main.tsx). The -apple-system stack stays as a
  // graceful fallback while the webfont loads. Geist Mono drives tabular figures
  // (MRR, invoices, etc.).
  fontFamily: {
    body: '"Plus Jakarta Sans Variable", -apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    display: '"Plus Jakarta Sans Variable", -apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    code: '"Geist Mono Variable", ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace',
  },
  radius: {
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '22px',
    xl: '30px',
  },
  shadow: {
    xs: '0 1px 3px rgba(16, 24, 40, 0.08)',
    sm: '0 4px 16px rgba(16, 24, 40, 0.10)',
    md: '0 14px 36px rgba(16, 24, 40, 0.14)',
    lg: '0 24px 60px rgba(16, 24, 40, 0.18)',
    xl: '0 36px 90px rgba(16, 24, 40, 0.22)',
  },
  colorSchemes: {
    light: {
      palette: {
        primary,
        background: {
          body: '#f6f7fb',
          surface: '#ffffff',
          level1: '#f0f2f7',
          level2: '#e8ebf2',
        },
      },
    },
    dark: {
      palette: {
        primary,
        background: {
          body: '#10121b',
          surface: '#1a1d29',
          level1: 'rgba(255, 255, 255, 0.05)',
          level2: 'rgba(255, 255, 255, 0.10)',
        },
      },
    },
  },
});

export default appTheme;
